(function () {
  function scrollSlider(direction, sliderId) {
    const slider = document.querySelector(
      `.wp-block-ms-slider[data-slider-id="${sliderId}"]`
    );
    if (!slider) {
      console.error(`Slider with ID ${sliderId} not found`);
      return;
    }

    // Get all slider items
    const items = Array.from(
      slider.querySelectorAll(".wp-block-ms-slider-item")
    );
    const activeIndex = items.findIndex((item) =>
      item.classList.contains("active")
    );

    // Determine the new active index
    let newIndex;
    if (direction === "prev") {
      newIndex = activeIndex > 0 ? activeIndex - 1 : items.length - 1;
    } else if (direction === "next") {
      newIndex = activeIndex < items.length - 1 ? activeIndex + 1 : 0;
    }

    // Remove active class from all items
    items.forEach((item) => item.classList.remove("active"));

    // Add active class to the new item
    items[newIndex].classList.add("active");

    // Scroll the new active item into view
    items[newIndex].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }

  // Initialize the first item as active
  document.addEventListener("DOMContentLoaded", () => {
    const sliders = document.querySelectorAll(".wp-block-ms-slider");
    sliders.forEach((slider) => {
      const items = slider.querySelectorAll(".wp-block-ms-slider-item");
      if (items.length > 0) {
        items[0].classList.add("active"); // Set the first item as active by default
      }
    });
  });

  // Expose the scrollSlider function to the global scope
  window.scrollSlider = scrollSlider;
})();
